import axios from "axios";
import React, { useState, useEffect } from "react";
import Header from "../../components/Header";

const ApproveUser = () => {
  const [users, setUsers] = useState([]); // State untuk menyimpan data user
  const [loading, setLoading] = useState(true); // State untuk loading
  const [error, setError] = useState(null); // State untuk menangkap error

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/approve-user`
      );
      setUsers(response.data.data);
    } catch (err) {
      setError("Gagal mengambil data user.");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/approve-user`, {
        userId: userId,
      });

      // Filter out the approved user from the list
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));

      alert("User berhasil di-approve!");
    } catch (error) {
      console.error("Error approving user:", error);
      alert("Gagal meng-approve user.");
    }
  };

  return (
    <>
      <Header title="Approve User" />
      <div className="flex flex-col items-center justify-center pt-24 pb-12 min-h-screen bg-gray-100 p-4">
        <h2 className="text-xl font-semibold mb-4">
          Daftar User Belum Di-approve
        </h2>

        {loading && <p>Loading...</p>}
        {error && <p className="text-red-500">{error}</p>}

        <div className="w-full max-w-4xl bg-white p-4 rounded-lg shadow-md overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-gray-300 px-4 py-2">Username</th>
                <th className="border border-gray-300 px-4 py-2">Name</th>
                <th className="border border-gray-300 px-4 py-2">
                  Device Info
                </th>
                <th className="border border-gray-300 px-4 py-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0
                ? users.map((user) => {
                    let deviceInfo = user.device_info;

                    if (typeof deviceInfo === "string") {
                      try {
                        deviceInfo = JSON.parse(deviceInfo);
                      } catch (error) {
                        console.error("Error parsing device_info:", error);
                        deviceInfo = {};
                      }
                    }

                    return (
                      <tr key={user.id} className="text-center">
                        <td className="border border-gray-300 px-4 py-2">
                          {user.username}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {user.name}
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-left">
                          <p>
                            <strong>Brand:</strong> {deviceInfo.brand || "N/A"}
                          </p>
                          <p>
                            <strong>Model:</strong> {deviceInfo.model || "N/A"}
                          </p>
                          <p>
                            <strong>OS:</strong>{" "}
                            {deviceInfo.systemName || "N/A"}{" "}
                            {deviceInfo.systemVersion || ""}
                          </p>
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <button
                            className="bg-blue-500 text-white px-2 py-1 rounded"
                            onClick={() => handleApprove(user.id)}
                          >
                            Approve
                          </button>
                        </td>
                      </tr>
                    );
                  })
                : !loading && (
                    <tr>
                      <td
                        colSpan="4"
                        className="border border-gray-300 px-4 py-2 text-center"
                      >
                        Tidak ada user yang perlu di-approve.
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ApproveUser;
